export interface AiPmSuggestionDto {
  id: string;
  projectId?: string;
  issueId?: string;
  sprintId?: string;
  versionId?: string;
  kind: number;
  kindLabel: string;
  provider: string;
  outputJson: string;
  confidence?: number;
  appliedAt?: string;
  createdAt: string;
}

export const AI_PM_ACTIONS = [
  { id: 'suggest-tasks', label: 'Suggest tasks', needs: 'prompt' as const },
  { id: 'generate-story', label: 'Generate story', needs: 'prompt' as const },
  { id: 'acceptance-criteria', label: 'Acceptance criteria', needs: 'issue' as const },
  { id: 'predict-risk', label: 'Predict risk', needs: 'issue' as const },
  { id: 'predict-deadline', label: 'Predict deadline', needs: 'issue' as const },
  { id: 'duplicates', label: 'Find duplicates', needs: 'issue' as const },
  { id: 'daily-summary', label: 'Daily summary', needs: 'project' as const },
  { id: 'weekly-report', label: 'Weekly report', needs: 'project' as const },
  { id: 'standup', label: 'Standup', needs: 'project' as const },
  { id: 'sprint-plan', label: 'Sprint plan', needs: 'sprint' as const },
  { id: 'release-notes', label: 'Release notes', needs: 'version' as const },
  { id: 'categorize-bug', label: 'Categorize bug', needs: 'issue' as const }
];
